var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteRed(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5292_72510)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.96956,
    fill: "#EF4626"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M7.4397 23.8528V12.4129C7.4397 9.70714 9.63512 7.51172 12.3408 7.51172H15.1415",
    stroke: "#F3F3F3",
    strokeWidth: 0.93695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.7806 10.4297V20.232C23.7806 22.2256 22.1548 23.8514 20.1612 23.8514H11.9016",
    stroke: "#F3F3F3",
    strokeWidth: 0.93695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.605 12.1172L20.2917 20.7921",
    stroke: "#F3F3F3",
    strokeWidth: 0.93695,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.3155 12.1172L11.605 20.7921",
    stroke: "#F3F3F3",
    strokeWidth: 0.93695,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5292_72510"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 6.96956,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteRed);
export default __webpack_public_path__ + "static/media/deleteRed.19f83c9338b934d423d30c0a7145a8ff.svg";
export { ForwardRef as ReactComponent };